import { Link } from 'react-router-dom'
import logo from '../assets/logo2.png'
import dp from '../assets/Ellipse 68.svg'
import userStore from '../store/userStore'
import { observer } from "mobx-react";
const Header = observer(()=> {
    return (
        <div className="fixed top-0 w-full bg-white flex justify-between items-center md:px-20 lg:px-20 md:p-[1%] lg:p-[1%] p-[5%] h-20 shadow-xl z-50">
            {/* <p className="flex justify-center items-center gap-1 max-md:text-xs">my <span className="text-primary">credit report.in</span></p> */}
            <img className='ml-2' src={logo} width={180} alt=''></img>
            { userStore.loggedIn ? 
                <div className='flex gap-8 items-center'>
                    <Link to='/faqs'><p className='text-semibold'>FAQ</p></Link>
                    <div className='rounded-full overflow-hidden'>
                        <img className='object-cover' src={dp} width={30} alt=''></img>
                    </div>
                </div>:
                <Link to='/register'><button className="border-primary border px-4 text-primary rounded-md md:h-10 h-8 max-md:text-xs">login</button></Link>
            }
        </div>
    );
});

export default Header;
